import axios from '@/extensions/axios'
import arrayAxios from '@/extensions/arrayAxios'

const translationIndex = {}

const actions = {
  get ({ commit, rootState }, queryParams) {
    return axios.get('brands/' + rootState.brand.active.uuid + '/messages', {
      params: queryParams
    }).then(response => {
      response.data.forEach(message => {
        translationIndex[message.uuid] = {}
        message.translations.forEach(translation => {
          translationIndex[message.uuid][translation.language] = translation.translation
        })
      })

      commit('SET', response)
    })
  },

  remove ({ commit, rootState, state }, message) {
    axios.delete('/messages/' + message.messageId).then(() => {
      commit('REMOVE', message.messageId)
    })
  },

  update ({ state, rootState, commit }, message) {
    let promises = []
    const language = rootState.site.active.defaultLanguage.code
    promises.push(axios.put('messages/' + message.messageId, {
      message: message.message,
      context: message.context
    }))
    if (typeof translationIndex[message.messageId][language] !== 'undefined') {
      promises.push(axios.put('translations/' + message.messageId + '/' + language, {
        translation: message.translations[language]
      }))
    } else {
      promises.push(axios.post('translations/' + message.messageId + '/' + language, {
        translation: message.translations[language]
      }))
      translationIndex[message.messageId][language] = message.translations[language]
    }
    Promise.all(promises).then(() => {
      commit('DISABLE_EDIT', message)
    })
  },

  saveAll ({ state, rootState, commit, dispatch }) {
    const language = rootState.site.active.defaultLanguage.code

    state.newTranslations.forEach(translation => {
      dispatch('create', translation)
    })

    const requests = []
    state.translations.forEach(message => {
      if (message.edit) {
        message.context = message.context || 'default'
        requests.push({
          method: 'put',
          url: '/messages/' + message.messageId,
          data: {
            message: message.message,
            context: message.context
          }
        })
        if (typeof translationIndex[message.messageId][language] !== 'undefined') {
          requests.push({
            method: 'put',
            url: '/translations/' + message.messageId + '/' + language,
            data: {
              translation: message.translations[language]
            }
          })
        } else {
          requests.push({
            method: 'post',
            url: '/translations/' + message.messageId + '/' + language,
            data: {
              translation: message.translations[language]
            }
          })
          translationIndex[message.messageId][language] = message.translations[language]
        }
      }
    })
    arrayAxios.sendRequests(requests).then(() => {
      state.translations.forEach(message => {
        commit('DISABLE_EDIT', message)
      })
    })
  },

  create ({ state, rootState, commit }, translation) {
    axios.post('brands/' + rootState.brand.active.uuid + '/messages', {
      message: translation.message,
      context: translation.context
    }).then(({ data }) => {
      let message = data
      message.messageId = message.uuid
      message.translations = {}
      message.translations[rootState.site.defaultLanguage.language.code] = translation.translation
      axios.post('translations/' + message.messageId + '/' + rootState.site.active.defaultLanguage.code, {
        translation: translation.translation
      }).then(() => {
        commit('ADD', message)
        commit('REMOVE_NEW', translation.localId)
      })
    })
  },

  getContexts () {
    return axios.get('messages/contexts')
  }
}

export default actions
